var path = 'src/app/patients/fuan/clinical-pictures.html';
var html = "<h1 class=page-header>ADTKD Clinical Pictures</h1> <div fuan-clinical-pictures-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/fuan/clinical-pictures.html
 ** module id = 473
 ** module chunks = 0
 **/